module.exports = __webpack_public_path__ + "img/wand.01df4a15.svg";